export function ExportRoute() {
  return (
    <section>
      <h1 style={{ marginTop: 0 }}>エクスポート</h1>
      <p style={{ color: "var(--color-text-sub)" }}>
        エクスポート機能は準備中です。モバイルアプリ側からエクスポートセッションを開始すると、ここで
        PC にダウンロードできるようになります。
      </p>
    </section>
  );
}
